<app-loader [Parent]="this"></app-loader>
@if (Model) {
  <div>
    <app-pageheader [Parent]="this">
      <form-edit-button>Edit</form-edit-button>
    </app-pageheader>
    <div class="columns is-multiline">
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">
            Citation Reason Details
          </p>
          <a class="panel-block">
            <span class="label">Name</span>
            <span class="value">{{Model.Name}}</span>
          </a>
          <a class="panel-block">
            <span class="label">Description</span>
            <span class="value">{{Model.Description}}</span>
          </a>
          <a class="panel-block">
            <span class="label">Base Fine</span>
            <span class="value">{{Model.BaseFine | currency}}</span>
          </a>
          <a class="panel-block">
            <span class="label">Active</span>
            <span class="value">{{Model.IsActive ? 'Yes' : 'No'}}</span>
          </a>
          <a class="panel-block">
            <span class="label">Appeal Eligible</span>
            <span class="value">{{Model.AppealEligible ? 'Yes' : 'No'}}</span>
          </a>
        </article>
      </div>
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">Pricing Schedule</p>
          <div class="panel-block">
            @if (Model.Escalations?.length) {
              <table class="table is-fullwidth">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Days After Issuance</th>
                    <th>Additional Fee</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  @for (escalation of Model.Escalations; track escalation) {
                    <tr>
                      <td>{{escalation.Sequence}}</td>
                      <td>{{escalation.DaysAfterIssuance}}</td>
                      <td>{{escalation.AdditionalFee | currency}}</td>
                      <td>{{escalation.Description || '-'}}</td>
                    </tr>
                  }
                </tbody>
              </table>
            } @else {
              <p>No escalation steps configured.</p>
            }
          </div>
        </article>
      </div>
    </div>
  </div>
}